$(function(){
  let list = '';
  if (window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches) {
		var limit = 4;	//表示件数
	} else {
		var limit = 6;	//表示件数
	}
  const accessToken = 'EAAUjuCBZCcnwBPoUOw6zmj377hamNUY9oZBxjkUZAYNkN6rPvZAgETzXPUMyapUBGa1jeUE1KMpme3OsEDuZBR89bwSo13AMCPk3ss9DVU3WTccGZAYj3meDt7TBnVvjL3GROY3c2DiynCYYH2goZB414hNZC79jvg7uJkdBpTTgCGKhAluQdF5NK1M3uw9HZBoB7'; // アクセストークン
  const businessID = '17841477502721630'; //instagram_business_accountのID
  const url = `https://graph.facebook.com/v12.0/${businessID}?fields=name,media.limit(${limit}){caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}&access_token=${accessToken}`;
  $.ajax({
    url: url
  }).done((res)=> {
    const data = res.media;
    $.each(data, function(index, val) {
      $.each(val, function(i, item) {
        if(item.media_url){
          //メディアのタイプがビデオの場合、サムネを取得
          media = (item.media_type == 'VIDEO' ? item.thumbnail_url : item.media_url);

          // 一覧を変数listに格納
          list +=
          `<a class="sec-inst_list_item" href="${item.permalink}" target="_blank" rel="noopener"><img src="${media}"></a>`;
        }

      })
    });
  $('#instalist').html(`<div class="sec-inst_list">${list}</div>`);
  }).fail(function(jqXHR, status) {
    $('#instalist').html('<p>読み込みに失敗しました。</p>');
  });
});